import { setCookie, getCookie, clearCookie } from "../utils/cookie";
import { Modal } from "bootstrap";

export default class CookieConsent extends HTMLDivElement {

    necessaryValue = "necessary";
    statisticsValue = "statistics";
    marketingValue = "marketing";

    connectedCallback() {

        this.addEventListener("shown.bs.modal", this.trapFocus);
        this.addEventListener("hide.bs.modal", this.resetFocus);

        if (!getCookie(this.dataset.cookieName)) {
            this.modal.show();
        }

        this.allButton?.addEventListener("click", this.acceptAll);
        this.necessaryButton?.addEventListener("click", this.acceptNecessary);
        this.settingsButton?.addEventListener("click", this.showSettings);
        this.saveSettingsButton?.addEventListener("click", this.acceptSelection);
        
        document.querySelector(`a[href='#${this.id}']`).addEventListener("click", this.showDialog);
    }

    showDialog = () => {
        this.querySelector("#cookie-consent-page1").classList.remove("d-none");
        this.querySelector("#cookie-consent-page2").classList.add("d-none");

        const selecedCookies = getCookie(this.dataset.cookieName)?.split("|");

        selecedCookies.forEach(cookieName => {
            const checkbox = this.querySelector(`input[value="${cookieName}"]`);

            if (checkbox)
                checkbox.checked = true;
        });

        this.modal.show();
    }

    trapFocus = () => {
        document.querySelectorAll("body > header, body > main, body > footer").forEach(el => {
            el.inert = true;
        });
    }

    resetFocus = () => {
        document.querySelectorAll("body > header, body > main, body > footer").forEach(el => {
            el.inert = false;
        });
    }

    acceptAll = () => {
        this.checkboxes.forEach(cb => cb.checked = true);
        this.setCookie();
    }

    acceptNecessary = () => {
        this.checkboxes
            .forEach(cb => cb.checked = cb.value == "necessary");
        this.setCookie();
    }

    acceptSelection = () => {
        this.setCookie();
    }

    setCookie = () => {

        const selectedCookies = this.checkboxes.filter(cb => cb.checked).map(cb => cb.value);

        setCookie(this.dataset.cookieName, selectedCookies.join("|"));

        const event = new CustomEvent("CookieConsent.save", { detail: selectedCookies });
        this.dispatchEvent(event);

    }

    showSettings = () => {
        this.querySelector("#cookie-consent-page1").classList.add("d-none");
        this.querySelector("#cookie-consent-page2").classList.remove("d-none");
        this.querySelector("#cookie-consent-page2 .modal-title").focus();
    }

    get modal() {
        return Modal.getOrCreateInstance(this, { backdrop: 'static', keyboard: false });
    }

    get checkboxes() {
        return Array.from(this.querySelectorAll("input[type=checkbox]"));
    }

    get allButton() {
        return this.querySelector("[data-cookie-consent=all]");
    }

    get necessaryButton() {
        return this.querySelector("[data-cookie-consent=necessary]");
    }

    get settingsButton() {
        return this.querySelector("[data-cookie-consent=showsettings]");
    }

    get saveSettingsButton() {
        return this.querySelector("[data-cookie-consent=save]");
    }

}

customElements.define('cookie-consent', CookieConsent, { extends: 'div' });